/**
 * Человекочитаемая длительность из секунд. null/0-выборка → «нет данных».
 * < 1ч → «Nм»; < 24ч → «Xч Yм»; иначе → «Nд Xч».
 */
export function formatDuration(seconds: number | null): string {
  if (seconds === null) return 'нет данных'
  if (seconds < 60) return '< 1 мин'
  const totalMin = Math.round(seconds / 60)
  const days = Math.floor(totalMin / (60 * 24))
  const hours = Math.floor((totalMin % (60 * 24)) / 60)
  const mins = totalMin % 60
  if (days > 0) return `${days} д ${hours} ч`
  if (hours > 0) return `${hours} ч ${mins} м`
  return `${mins} м`
}

export function onTimeRate(onTime: number, overdue: number): string {
  const total = onTime + overdue
  if (total === 0) return '—'
  return `${Math.round((onTime / total) * 100)}%`
}
